import React from 'react'
import reactStamp from 'react-stamp'
import req from 'reqwest';
import Health from '../components/Health'
import TestForm from 'json!../../www/resources/patient-form-portal-response.json'

export default reactStamp(React).compose({

    init(){
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleDiscardChanges = this.handleDiscardChanges.bind(this);
        this.handleSaveChanges = this.handleSaveChanges.bind(this);
        this.createNew = this.createNew.bind(this);
        this.removeGroupItem = this.removeGroupItem.bind(this);
        this.editChanges = this.editChanges.bind(this);
        this.getBasicHealthInfo();
        this.state.editMode = false;
    },

    state: {
        editMode: false,
        form: {
            conditions: [],
            allergies: []
        }
    },

    getBasicHealthInfo(){
        let id = sessionStorage.getItem("id");
        req({
            url: "https://portal-experience-api.cloudhub.io/api/patient/" + id + "/health",
            method: 'GET',
            crossOrigin: true,
            credentials: true
        })
            .then((resp)=> {
                this.handleGetHealthInfoResponse(resp)
            })
            .fail((err, msg) => this.handleGetHealthInfoError(err, msg))
            .always((resp) => {
            })
    },

    handleGetHealthInfoResponse(resp){
        let _state = this.state;
        _state.form = resp;

        for (let _condition of TestForm.conditions) {
            let isPresented = false;
            for (let condition of _state.form.conditions) {
                if (condition.code == _condition.code) {
                    isPresented = true;
                }
            }
            if (!isPresented) {
                _state.form.conditions.push(_condition);
            }
        }

        for (let _allergy of TestForm.allergies) {
            let isPresented = false;
            for (let allergy of _state.form.allergies) {
                if (allergy.name == _allergy.name) {
                    isPresented = true;
                }
            }
            if (!isPresented) {
                _state.form.allergies.push(_allergy);
            }
        }
        this.setState(_state);
    },

    handleGetHealthInfoError(err, msg){
    },

    render() {
        return (
            <Health
                conditions={this.state.form.conditions}
                allergies={this.state.form.allergies}
                handleNameChange={this.handleNameChange}
                handleDateChange={this.handleDateChange}
                handleDiscardChanges={this.handleDiscardChanges}
                handleSaveChanges={this.handleSaveChanges}
                createNew={this.createNew}
                removeGroupItem={this.removeGroupItem}
                editMode={this.state.editMode}
                editChanges={this.editChanges}
            />
        );
    },

    handleNameChange(item){
        let _form = this.state.form;
        switch (item.type) {
            case "allergy":
                for (let _allergy of _form.allergies) {
                    if (_allergy.id == item.oldId) {
                        _allergy.status = "false";
                        _allergy.rowNumber = undefined;
                    } else if (_allergy.id == item.newId) {
                        _allergy.status = "true";
                        _allergy.rowNumber = item.rowNumber;
                    }
                }
                break;
            case "condition":
                for (let _condition of _form.conditions) {
                    if (_condition.id == item.oldId) {
                        _condition.status = "false";
                        _condition.rowNumber = undefined;
                    } else if (_condition.id == item.newId) {
                        _condition.status = "true";
                        _condition.rowNumber = item.rowNumber;
                    }
                }

                break;
            default:
                break;
        }
        this.setState({form: _form});
    },

    handleDateChange(item){
        let _form = this.state.form;
        switch (item.type) {
            case "allergy":
                for (let _allergy of _form.allergies) {
                    if (_allergy.id == item.id) {
                        _allergy.onsetDate = item.onsetDate;
                    }
                }
                break;
            case "condition":
                for (let _condition of _form.conditions) {

                    if (_condition.id == item.id) {
                        _condition.onsetDate = item.onsetDate;
                    }
                }

                break;
            default:
                break;
        }
        this.setState({form: _form})
    },

    handleDiscardChanges(){

        this.setState({editMode: false})
        let _form = this.state.form;
        for (let _allergy of _form.allergies) {
            _allergy.status = "";
        }
        for (let _condition of _form.conditions) {
            _condition.status = "";
        }
        this.setState({form: _form})
    },

    handleSaveChanges(){
        this.setState({editMode: false})
        let id = sessionStorage.getItem("id");
        let _state = this.state;
        let updateData = {conditions:{}, allergies:{}};

        //todo: temporary solution
        updateData.conditions = this.state.form.conditions.filter((el) => {
            return el.id != "" && el.status != "NA";
        });
        updateData.allergies = this.state.form.allergies.filter((el) => {
            return el.id != "" && el.status != "NA";
        });
        this.state.form.conditions = this.state.form.conditions.filter((el) => {
            return el.id != "";
        });
        this.state.form.allergies = this.state.form.allergies.filter((el) => {
            return el.id != "";
        });

        req({
            url: "https://portal-experience-api.cloudhub.io/api/patient/" + id + "/health",
            method: 'PUT',
            contentType: "application/json",
            crossOrigin: true,
            data: JSON.stringify(updateData)
        })
            .then((resp) => this.handlePutFormResponse(resp))
            .fail((err, msg) => this.handlePutFormError(err, msg))
            .always((resp) => {
            });
    },

    handlePutFormResponse(resp){
        console.log(resp)
    },

    handlePutFormError(err, msg){
    },

    createNew(type){
        let _form = this.state.form;
        switch (type) {
            case "allergy":
                _form.allergies.push({
                    "id": "",
                    "onsetDate": "",
                    "status": "true"
                });
                break;
            case "condition":
                _form.conditions.push({
                    "id": "",
                    "onsetDate": "",
                    "status": "true"
                })
                break;
            default:
                break;
        }

        this.setState({form: _form})

    },

    removeGroupItem(item, type){
        let _form = this.state.form;
        switch (type) {
            case "allergy":
                for (let _allergy of _form.allergies) {
                    if (_allergy.id == item)
                        _allergy.status = "false";
                    _allergy.rowNumber = undefined;
                }
                break;
            case "condition":
                for (let _condition of _form.conditions) {
                    if (_condition.id == item)
                        _condition.status = "false";
                    _condition.rowNumber = undefined;
                }
                break;
            default:
                break;
        }

        this.setState({form: _form});
    },

    editChanges(){
        let _state = this.state;
        _state.editMode = true;
        this.setState(_state);
    }

});


/** WEBPACK FOOTER **
 ** ./src/app/containers/Health.js
 **/